import Centrifuge, { Message, Subscription } from 'centrifuge';

import { PlayerSettings } from '@/api/common';
import { REACT_APP_API_URL } from '@/helpers/conf';
import { CLIENT_ENVS } from '@/helpers/constants';

export class RealTimeService {
  private static instance: RealTimeService | null = null;

  private static centrifugeInstance: Centrifuge | null = null;
  private static subscriptions: Map<string, Subscription> = new Map();

  private constructor() {}

  public static getInstance(): RealTimeService {
    if (!RealTimeService.instance) {
      RealTimeService.instance = new RealTimeService();
    }
    return RealTimeService.instance;
  }

  public connect(playerSettings: PlayerSettings): void {
    if (RealTimeService.centrifugeInstance) {
      this.disconnect();
    }

    const apiUrl =
      CLIENT_ENVS.APP_ENV === 'development' ? '' : REACT_APP_API_URL;

    const centrifugeConfig = {
      url: playerSettings.cent.url + '/connection/websocket',
      user: playerSettings.cent.user,
      timestamp: playerSettings.cent.timestamp,
      token: playerSettings.cent.token,
      authEndpoint: `${apiUrl}${playerSettings.cent.authEndpoint}`,
    };

    RealTimeService.centrifugeInstance = new Centrifuge(centrifugeConfig);

    RealTimeService.centrifugeInstance.on('connect', (ctx) => {
      console.log('RealTimeService connected.', { clientID: ctx.client });
    });

    RealTimeService.centrifugeInstance.on('disconnect', (ctx) => {
      console.log('RealTimeService disconnected.', { reason: ctx.reason });

      RealTimeService.subscriptions.clear();
    });

    RealTimeService.centrifugeInstance.connect();
  }

  public disconnect(): void {
    if (RealTimeService.centrifugeInstance) {
      RealTimeService.centrifugeInstance.disconnect();
      RealTimeService.centrifugeInstance = null;
      RealTimeService.subscriptions.clear();
    }
  }

  public subscribe<T>(channel: string, onMessage: (data: T) => void): void {
    if (
      !RealTimeService.centrifugeInstance ||
      RealTimeService.subscriptions.has(channel)
    )
      return;

    const sub = RealTimeService.centrifugeInstance.subscribe(
      channel,
      (context: Message<T>) => {
        onMessage(context.data);
      }
    );
    RealTimeService.subscriptions.set(channel, sub);
  }

  public unsubscribe(channel: string): void {
    if (RealTimeService.subscriptions.has(channel)) {
      const sub = RealTimeService.subscriptions.get(channel);
      sub?.unsubscribe();
      sub?.removeAllListeners();
      RealTimeService.subscriptions.delete(channel);
    }
  }
}
